import * as Iconoir from "iconoir-react"
import React, { useState } from "react"
import GiftSubscriptionModal from "./GiftSubscriptionModal"

export default function GiftSubscriptionBanner(): React.JSX.Element {
  const [showModal, setShowModal] = useState(false)

  const handleGiftClick = () => {
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setShowModal(false)
  }

  return (
    <div className="mb-4">
      <div
        onClick={handleGiftClick}
        className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg text-center cursor-pointer hover:bg-emerald-100 transition-colors"
      >
        <div className="flex items-center justify-center gap-2">
          <Iconoir.Gift className="w-5 h-5 text-emerald-600" />
          <h3 className="font-semibold text-sm text-emerald-800">Share the Love</h3>
        </div>
        <p className="text-xs mt-1 text-emerald-700">Give friends 30 days of unlimited AI calls</p>
      </div>

      <GiftSubscriptionModal show={showModal} onClose={handleCloseModal} />
    </div>
  )
}
